import React from "react";
import "./App.css";
import { ThemeProvider } from "./context/ThemeContext";
import useScrollReveal from "./hooks/useScrollReveal";
import useCardTilt from "./hooks/useCardTilt";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Differentiation from "./components/Differentiation";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Security from "./components/Security";
import Industries from "./components/Industries";
import AboutUs from "./components/AboutUs";
import TrustedBy from "./components/TrustedBy";
import ContactUs from "./components/ContactUs";
import Footer from "./components/Footer";
import CtaBanner from "./components/CtaBanner";

function App() {
  useScrollReveal();
  useCardTilt();

  return (
    <ThemeProvider>
      <div className="dark-container">
        <Header />
        <main>
          <Hero />
          <Differentiation />
          <Features />
          <CtaBanner
            heading="See it running on your own use case"
            subtext="Tell us what you're building and we'll show you the components that fit."
          />
          <HowItWorks />
          <Security />
          <Industries />
          <AboutUs />
          <TrustedBy />
          <CtaBanner
            heading="Ready to deploy your first application?"
            subtext="No code, no integration backlog — just the components you need, live."
          />
          <ContactUs />
        </main>
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;